import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { SocialPlatform, SocialPlatformEnum, socialPlatforms } from '../domain/platforms';

/**
 * Hook that returns all enabled social platforms.
 * For now, returns all registered platforms.
 */
export function useEnabledSocialPlatforms(): SocialPlatform[] {
  const isTikTokEnabled = useFeatureIsOn('app__social_export_tiktok');

  return socialPlatforms.all().filter((platform) => {
    if (platform.id === SocialPlatformEnum.TIKTOK) {
      return isTikTokEnabled;
    }

    return true;
  });
}
